import { DisplayVariantType, TitleVariantType } from '@purpurds/purpur';
import {
  TeliaCol,
  TeliaGrid,
  TeliaHeading,
  TeliaIcon,
  TeliaLink,
  TeliaRow,
} from '@teliads/components/react';
import './CardContentWrapper.scss';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  title?: string;
  preamble?: ReactNode;
  isTitleCentered?: boolean;
  titleVariant?: TitleVariantType | DisplayVariantType;
  children: ReactNode;
  cta?: {
    text?: string;
    url?: string;
  };
};

const CardContentWrapper = ({
  title,
  preamble,
  children,
  isTitleCentered = false,
  titleVariant = 'title-300',
  cta,
}: Props) => {
  const { t } = useTranslation();
  return (
    <TeliaGrid>
      {(title || preamble) && (
        <TeliaRow>
          <TeliaCol width={12} className="card-content-wrapper__text-container">
            {title && (
              <TeliaHeading
                tag="h3"
                variant={titleVariant}
                className={`card-content-wrapper__title ${
                  isTitleCentered ? 'card-content-wrapper__title--centered' : ''
                }`}
              >
                {title}
              </TeliaHeading>
            )}
            {preamble && (
              <div className={isTitleCentered ? 'card-content-wrapper__preamble' : ''}>
                {preamble}
              </div>
            )}
          </TeliaCol>
        </TeliaRow>
      )}

      <div>{children}</div>
      {cta && (
        <TeliaLink href={cta.url} variant="standalone">
          {cta.text ?? t('read_more')}
          <TeliaIcon name="arrow-right" slot="right" size="sm" />
        </TeliaLink>
      )}
    </TeliaGrid>
  );
};

export default CardContentWrapper;
